import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "field",
  style: {"text-align":"right"}
}
const _hoisted_2 = { class: "control is-small" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveButton',
  props: {
    action: null,
    inProgressAction: null,
    label: null,
    icon: null,
    iconRight: { type: Boolean },
    large: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {




// Event for two-way binding

const onClick = () => {
  emit('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "submit",
        value: "Save",
        class: _normalizeClass(["formButton button is-link", { 'is-small': !__props.large, 'is-loading': __props.action && (__props.inProgressAction == __props.action) }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick()))
      }, [
        (__props.icon && !__props.iconRight)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(["fa mr-2", __props.icon])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(__props.label ? __props.label : 'Save'), 1),
        (__props.icon && __props.iconRight)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: _normalizeClass(["fas ml-2", __props.icon])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})